import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { PiasLayoutComponent } from '../../../../shared/components/pias-layout/pias-layout.component';
import { SelectOptions } from '../../../../core/interfaces/select-options.interface';
import { MatSelectModule } from '@angular/material/select';
import { SnackbarService } from '../../../../shared/services/snackbar/snackbar.service';
import { RecrutmentMangerComponentsService } from '../recruitment-manger-services/recrutment-manger-components.service';
import { HttpStatusCode } from 'axios';
import { ViewApplicationdetails } from '../recruitment-manger-interfaces/view-applicationdetails.interface';
import { SessionStorageService } from '../../../../core/services/session-storage/session-storage.service';


@Component({
  selector: 'app-view-onboarding-application',
  imports: [
    CommonModule,
    PiasLayoutComponent,
    RouterModule,
    MatCardModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    ReactiveFormsModule,
    MatDividerModule,
    MatSelectModule

  ],
  templateUrl: './view-onboarding-application.component.html',
  styleUrl: './view-onboarding-application.component.scss'
})
export class ViewOnboardingApplicationComponent implements OnInit {

  private formBuilder = inject(FormBuilder);
  private router = inject(Router);
  private recruitmentManagerService = inject(RecrutmentMangerComponentsService);
  private sessionStorageService = inject(SessionStorageService);
  private snackBarService = inject(SnackbarService);
  setSprinner = signal(false);
  viewId!: number;
  status!: string;
  data = history.state;
  protected currentUserRole: string = "";


  viewOnboardApplicationFg!: FormGroup;
  protected viewApplicationdetails!: ViewApplicationdetails;
  readonly DESIGNATION = {
    FAR: 'Financial Advisor Representative',
    FAM: 'Financial Advisor Manager',
    INDIVIDUAL: 'Introducer - Individual',
    CORPORATE: 'Introducer - Corporate',
  };
  get designation(): string {
    return this.viewOnboardApplicationFg.get('designation')?.value;
  }

  get isAgent(): boolean {
    return (
      this.designation === this.DESIGNATION.FAR ||
      this.designation === this.DESIGNATION.FAM
    );
  }

  get isIndividual(): boolean {
    return this.designation === this.DESIGNATION.INDIVIDUAL;
  }

  get isCorporate(): boolean {
    return this.designation === this.DESIGNATION.CORPORATE;
  }

  get showName(): boolean {
    return !this.isCorporate;
  }

  get showPreferredName(): boolean {
    return !this.isCorporate;
  }

  get showBranch(): boolean {
    return !this.isCorporate;
  }

  get showDirector(): boolean {
    return !this.isCorporate;
  }

  get showManager(): boolean {
    return !this.isCorporate;
  }

  get showReferral(): boolean {
    return this.isAgent;
  }

  get showCompany(): boolean {
    return this.isCorporate;
  }

  get emailLabel(): string {
    return this.isIndividual || this.isCorporate ? 'Email Address' : 'Personal EmailAddress';
  }

  ngOnInit(): void {
    this.viewOnboardApplicationFg = this.formBuilder.group({
      name: [''],
      preferredName: [''],
      branch: [''],
      financialServicesDirector: [''],
      financialServicesManager: [''],
      designation: [''],
      nameofReferral: [''],
      companyName: [''],
      personalEmailAddress: [''],
      remarksbyRecruitmentManager: [''],

    });
    this.currentUserRole = this.sessionStorageService.getCurrentUserRole();
    this.viewId = this.data.id;
    this.status = this.data.status;
    this.viewApplicationDetails();
  }

  async viewApplicationDetails() {
    this.setSprinner.set(true);
    const responseData = await this.recruitmentManagerService
      .getApplicationDetails(this.viewId)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);

    if (responseData.status === HttpStatusCode.Ok) {

      this.viewApplicationdetails = responseData.data.responsedata;
      this.viewOnboardApplicationFg.controls['name'].setValue(this.viewApplicationdetails.fullNameNric);
      this.viewOnboardApplicationFg.controls['companyName'].setValue(this.viewApplicationdetails.companyName);
      this.viewOnboardApplicationFg.controls['preferredName'].setValue(this.viewApplicationdetails.preferredName);
      this.viewOnboardApplicationFg.controls['branch'].setValue(this.viewApplicationdetails.branch);
      this.viewOnboardApplicationFg.controls['financialServicesDirector'].setValue(this.viewApplicationdetails.finacialServiceDir);
      this.viewOnboardApplicationFg.controls['financialServicesManager'].setValue(this.viewApplicationdetails.finacialServiceMan);
      this.viewOnboardApplicationFg.controls['designation'].setValue(this.viewApplicationdetails.designation);
      this.viewOnboardApplicationFg.controls['nameofReferral'].setValue(this.viewApplicationdetails.nameOfReferal);
      this.viewOnboardApplicationFg.controls['personalEmailAddress'].setValue(this.viewApplicationdetails.personalEmailAddress);
      this.viewOnboardApplicationFg.controls['remarksbyRecruitmentManager'].setValue(this.viewApplicationdetails.remarkContent);

    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  async navigateEditDetails() {
    this.router.navigate(['/agent-onboarding/edit-onboarding-application'], {
      state: { id: this.viewId }
    });
  }

}
